/**
 * Справочные описания административных районов
 */
export const REGION_DESCRIPTIONS = {
  1: {
    id: 1,
    name: 'Засвияжский',
    city_id: 1,
    formed: '1962',
    location: 'Правобережная часть Ульяновска',
    population: '~222 тыс.',
    areaSize: '~90 км²',
    summary: 'Крупнейший по населению район Ульяновска — правобережный промышленно-жилой массив.',
    description: 'Занимает значительную часть правого берега. Территорию делят на Ближнее и Дальнее Засвияжье. Развитие связано с автомобильной и машиностроительной промышленностью, широкими улицами и плотной жилой застройкой.',
    highlights: ['Правобережье', 'Промышленный центр', 'Ближнее и Дальнее Засвияжье'],
  },
  2: {
    id: 2,
    name: 'Ленинский',
    city_id: 1,
    formed: '1942',
    location: 'Исторический центр и северное правобережье',
    population: '~116 тыс.',
    areaSize: '~65 км²',
    summary: 'Исторический и административный центр Ульяновска — бывший Симбирск.',
    description: 'Включает исторический центр города с улицей Гончарова, бульваром Венец, мемориальным комплексом и музеями. Сочетает старую застройку с современными кварталами, рельеф холмистый с видом на Волгу.',
    highlights: ['Исторический центр', 'Бульвар Венец', 'Административные учреждения'],
  },
  3: {
    id: 3,
    name: 'Железнодорожный',
    city_id: 1,
    formed: '1966',
    location: 'Южная правобережная часть города',
    population: '~85 тыс.',
    areaSize: '~55 км²',
    summary: 'Южный транспортно-промышленный район с железнодорожным узлом и речным портом.',
    description: 'Расположен на юге правого берега. Здесь сосредоточены вокзалы, объекты грузовой логистики и Ульяновский речной порт. Важен для транспортной и городской инфраструктуры.',
    highlights: ['Железнодорожный узел', 'Речной порт', 'Логистика'],
  },
  4: {
    id: 4,
    name: 'Заволжский',
    city_id: 1,
    formed: '1962',
    location: 'Левобережная часть города',
    population: '~216 тыс.',
    areaSize: '~99 км²',
    summary: 'Самый обширный район Ульяновска на левом берегу Волги.',
    description: 'Связан с центром мостами через Волгу. Крупные жилые массивы — микрорайон Авиастроителей, Нижняя и Верхняя террасы. Один из самых населённых районов города.',
    highlights: ['Левый берег Волги', 'Авиастроители', 'Крупнейший по площади'],
  },
  5: {
    id: 5,
    name: 'Ленинский',
    city_id: 2,
    formed: '1972',
    location: 'Центр и юго-запад Саранска',
    population: '~104 тыс.',
    areaSize: '32 км²',
    summary: 'Центральный район Саранска — административное и культурное ядро столицы Мордовии.',
    description: 'Охватывает исторический центр, Дом Республики, вузы, театры и парки. Условно делится на центр, Юго-Запад и Низы. Развитая социальная и деловая инфраструктура.',
    highlights: ['Центр города', 'Вузы и театры', 'Дом Республики'],
  },
  6: {
    id: 6,
    name: 'Октябрьский',
    city_id: 2,
    formed: '1985',
    location: 'Север, восток и юго-восток Саранска',
    population: '~121 тыс.',
    areaSize: '28 км²',
    summary: 'Самый населённый район Саранска с микрорайонами Химмаш и ТЭЦ.',
    description: 'Включает жилые массивы Химмаш, ТЭЦ-2, им. Гагарина и пригородные населённые пункты. Активно застраивается многоэтажной жилой застройкой.',
    highlights: ['Химмаш и ТЭЦ', 'Жилищное строительство', 'Самый населённый'],
  },
  7: {
    id: 7,
    name: 'Пролетарский',
    city_id: 2,
    formed: '1972',
    location: 'Северо-запад Саранска',
    population: '~91 тыс.',
    areaSize: '26 км²',
    summary: 'Северо-западный район с жилым массивом Светотехника.',
    description: 'Ключевой жилой массив — Светотехника. Сочетает жилую застройку с промышленными зонами. Спокойный спальный район с развитой инфраструктурой.',
    highlights: ['Светотехника', 'Северо-запад', 'Жилой массив'],
  },
};

export function getRegionDescription (regionId) {
  return REGION_DESCRIPTIONS[regionId] || null;
}
